import React from 'react';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  FormGroup,
  Label,
  Input
} from 'reactstrap';
import moment from 'moment';
import ICheckList from '../models/CheckList';
import Button from './Button';
import Icon from './Icon';
import CheckListPhotoGallery from './CheckListPhotoGallery';

type Props = {
  open: boolean;
  onClose: () => void;
  checkList: ICheckList;
};

const ModalViewCheckList = ({ open, onClose, checkList }: Props) => {
  return (
    <Modal isOpen={open} toggle={onClose} size="xl">
      <ModalHeader className="border-0">
        <div className="d-flex justify-content-between align-items-center w-100">
          <span className="fw-bolder h5 mb-0">Checklist Details</span>
          <Button
            color="light"
            className="text-primary"
            onClick={onClose}
            size="sm"
          >
            <Icon local icon="close" width={20} />
          </Button>
        </div>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md={7}>
            <div className="mb-4">
              <h6 className="text-secondary mb-3">Photos</h6>
              <CheckListPhotoGallery
                pictures={checkList.pictures_details || []}
                loading={false}
              />
            </div>

            {checkList.note && (
              <div className="mb-3">
                <h6 className="text-secondary mb-2">Quality Control Notes</h6>
                <div
                  className="p-3 bg-light rounded"
                  style={{ whiteSpace: 'pre-wrap' }}
                >
                  {checkList.note}
                </div>
              </div>
            )}
          </Col>

          <Col md={5}>
            <div className="bg-light p-3 rounded">
              <h6 className="text-secondary mb-3">Checklist Items</h6>
              {checkList.items_details?.map((item) => (
                <div
                  key={item.id}
                  className="d-flex justify-content-between align-items-center mb-2"
                >
                  <Label check className="mb-0">
                    {item.item}
                  </Label>
                  <FormGroup switch className="mb-0">
                    <Input
                      type="switch"
                      role="switch"
                      checked={true}
                      disabled
                      readOnly
                    />
                  </FormGroup>
                </div>
              ))}

              {(!checkList.items_details ||
                checkList.items_details.length === 0) && (
                <p className="small text-secondary text-center mb-0">
                  No checklist items
                </p>
              )}

              <div className="mt-4 pt-3 border-top">
                <p className="small text-secondary mb-1">
                  <strong>Completed by:</strong>
                </p>
                {checkList.user_detail ? (
                  <>
                    <p className="small mb-1">
                      {checkList.user_detail.first_name}{' '}
                      {checkList.user_detail.last_name}
                    </p>
                    <p className="small text-secondary mb-0">
                      {moment(checkList.data_cadastro).format(
                        'MMM DD, YYYY [at] h:mm A'
                      )}
                    </p>
                  </>
                ) : (
                  <p className="small text-secondary mb-0">Unknown user</p>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ModalViewCheckList;
